import { aboutData } from '@/mocks/homeData';

export default function AboutSection() {
  return (
    <section id="about" className="py-12 md:py-16 bg-background-100">
      <div className="section-container">
        <div className="max-w-4xl mx-auto">
          <div className="bg-background-50 rounded-2xl border border-background-200/70 p-6 md:p-10">
            <div className="text-center mb-6 md:mb-8">
              <h2 className="section-title">{aboutData.title}</h2>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-8">
              {aboutData.stats.map((stat, i) => (
                <div key={i} className="text-center p-3">
                  <p className="text-2xl md:text-3xl font-bold text-primary-600 mb-1">{stat.value}</p>
                  <p className="text-xs text-foreground-500">{stat.label}</p>
                </div>
              ))}
            </div>

            <div className="text-sm md:text-base text-foreground-600 leading-relaxed space-y-4">
              {aboutData.description.split('\n\n').map((paragraph, i) => (
                <p key={i}>{paragraph}</p>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}